import { useEffect, useState } from "react";
import { ArrowUpLeft, Download } from "lucide-react";
import { text } from "../data/content";

export default function ProductCard({ product, language, onQuote }) {
  const [imageState, setImageState] = useState("loading");
  const isBrochure = Boolean(product.downloadUrl);
  const requestProductQuote = () => onQuote(product.id);

  useEffect(() => {
    setImageState("loading");
  }, [product.image]);

  const handleCardKeyDown = (event) => {
    if (isBrochure || (event.key !== "Enter" && event.key !== " ")) return;
    event.preventDefault();
    requestProductQuote();
  };

  return (
    <article className="product-card" data-testid={`product-card-${product.id}`} role={isBrochure ? undefined : "button"} tabIndex={isBrochure ? undefined : 0} aria-label={text(language, isBrochure ? `تحميل ${product.ar}` : `اطلب عرض سعر لـ ${product.ar}`, isBrochure ? `Download ${product.en}` : `Request a quote for ${product.en}`)} onClick={isBrochure ? undefined : requestProductQuote} onKeyDown={isBrochure ? undefined : handleCardKeyDown}>
      {isBrochure ? (
        <div className="product-card-media brochure-card-media" data-testid={`brochure-preview-${product.id}`}>
          <img className="brochure-cover-image" src={product.coverImage} alt={text(language, product.ar, product.en)} loading="eager" decoding="async" onLoad={() => setImageState("loaded")} onError={() => setImageState("error")} data-testid={`brochure-cover-${product.id}`} data-image-state={imageState} />
          <span className="image-reference-note">{text(language, `PDF • ${product.pages} صفحات`, `PDF • ${product.pages} pages`)}</span>
        </div>
      ) : (
        <div className={`product-card-media ${product.imageFit === "contain" ? "product-card-media-contain" : ""}`} style={product.imageBackground ? { backgroundColor: product.imageBackground } : undefined}>
          <img key={product.image} src={product.image} alt={text(language, product.ar, product.en)} loading="eager" decoding="async" onLoad={() => setImageState("loaded")} onError={() => setImageState("error")} data-testid={`product-image-${product.id}`} data-image-state={imageState} />
          <span className="image-reference-note">{text(language, product.imageLabelAr || "مشروع Moonline", product.imageLabelEn || "Moonline project")}</span>
        </div>
      )}
      <div className="product-card-body">
        <div className="product-meta">
          <span>{text(language, product.categoryAr, product.categoryEn)}</span>
          <span>/{product.id.split("-")[0]}</span>
        </div>
        <h3>{text(language, product.ar, product.en)}</h3>
        <p>{text(language, product.descAr, product.descEn)}</p>
        {isBrochure ? (
          <a className="text-action brochure-download" href={product.downloadUrl} target="_blank" rel="noopener noreferrer" download={product.fileName} data-testid={`brochure-download-${product.id}`}>
            {text(language, "تحميل PDF", "Download PDF")} <Download size={15} strokeWidth={1.5} />
          </a>
        ) : (
          <button type="button" className="text-action" onClick={(event) => { event.stopPropagation(); requestProductQuote(); }} data-testid={`product-quote-${product.id}`}>
            {text(language, "اطلب هذا المنتج", "Request this product")} <ArrowUpLeft size={15} strokeWidth={1.5} />
          </button>
        )}
      </div>
    </article>
  );
}
